import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { useQuery } from "react-query";

const fetchGalaxyGraph = async (graphVar) => {
    const { plateId, wellId } = graphVar;
    const headerConfig = setHeaders();
    const { data: urlWrapper } = await axios.get(
        `${config.ENDPOINTS["datalake"]}/ddpcr/graph/galaxy/${plateId}/${wellId}`,
        { headers: headerConfig }
    );
    const { data: graphData } = await axios.get(urlWrapper.signedUrl);
    return graphData;
};

export default function useFetchGalaxyGraphData(graphVar) {
    return useQuery(["galaxyGraph", graphVar], () => fetchGalaxyGraph(graphVar), {
        enabled: !!(graphVar?.plateId && graphVar?.wellId),
        onError: (error) => console.log({ error }),
        refetchOnWindowFocus: false,
    });
}
